module.exports = __webpack_public_path__ + "static/media/carrot-loader-fast.f5a47345.gif";